import React from 'react';
import { punditStore } from 'stores/punditStore';
import BaseComponent from 'application/baseComponent';
import { t, } from 'providers/i18nProvider/i18nProvider';
import ExternalBetComponent from 'components/pundit/punditExternalBetComponent';


export default class ExternalTopPredictorsComponent extends BaseComponent {

  constructor(props){
    super(props, [ punditStore ]);
  }

  getState(props){
    return {
      data: punditStore.externalTopPredictors
    };
  }

  canRender(){
    return this.state.data !== undefined && this.state.data.length === 3;
  }

  getPredictors(){
    return this.state.data ? this.state.data.map((predictorData, index)=>{
      return <li key={ index } className="pundit-predictor">
              <img className="pundit-predictor__logo" src={ predictorData.predictor_logo } />
              <div className="pundit-predictor__info">
                <h4 className="pundit-predictor__info__name">{ predictorData.predictor_name }</h4>
                <div className="pundit-predictor__info__prediction">
                  <label className="pundit-predictor__info__prediction__text"> { t('pundit.prediction') } </label>
                  <label className="pundit-predictor__info__prediction__result"> { predictorData.predictor_winner } </label>
                </div>
              </div>
            </li>;
    }) : <div/>;
  }

  getCurrentView(){
    return <div className="pundit-top-predictors">
              <div className="pundit-top-predictors__header">
                <div className="pundit-section-heading">
                  <h1 className="pundit-section-heading__text"> { t('pundit.top_predictors') } </h1>
                </div>
              </div>
              <div className="pundit-top-predictors__wrapper">
                <ul className="pundit-top-predictors__list">
                  { this.getPredictors() }
                </ul>
                <div className="scroll-anchor.pundit-predictors-bet" />
                <div className="pundit-betting-wrapper">
                  <ExternalBetComponent topPredictors={ true }/>
                </div>
              </div>
            </div>;
  }

  render(){
    return this.canRender() ? this.getCurrentView() : <div/>;
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/pundit/punditExternalTopPredictorsComponent.js